var exports = {
  "Vg": "ComponentGalleryTabInputsTab.module__grid___Qk1rV3",
  "hK": "ComponentGalleryTabInputsTab.module__gridSingle___Qk1rV3",
  "T_": "ComponentGalleryTabInputsTab.module__inlineEditWrapper___Qk1rV3",
  "qF": "ComponentGalleryTabInputsTab.module__inlineEditLabel___Qk1rV3",
  "WX": "ComponentGalleryTabInputsTab.module__inlineEditCaption___Qk1rV3",
  "V1": "ComponentGalleryTabInputsTab.module__colorPickersGrid___Qk1rV3",
};

module.exports = exports;
